module.exports = __webpack_public_path__ + "img/chua-co-kq.12ba37a8.png";